module.exports = new __parcel__URL__("urban-1.eed0ef37.jpeg").toString();